import script from "./CoachingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingButton.vue?vue&type=script&setup=true&lang=js"

import "./CoachingButton.vue?vue&type=style&index=0&id=7d0edeb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0edeb2"]])

export default __exports__